import React from "react";
import { useTranslation } from "react-i18next";

export default function ScheduleAIRWeekTable({
  item,
  selectWeekDateList,
  handleCostModalOpen,
  sm_DEPARTURE_DATE,
}) {
  const { t } = useTranslation();
  const PlaneIcon = ({ data, date }) => {
    return (
      <button
        className={`border-0 bg-freiscop text-white rounded-sm d-flex flex-row align-items-center justify-content-center`}
        style={{ width: 30, height: 30 }}
        onClick={() => {
          handleCostModalOpen(item, { ...data, ...date });
        }}
      >
        <i className="fa-solid fa-plane-departure" />
      </button>
    );
  };

  const AirFreightItem = ({ data, date }) => {
    return (
      <>
        <PlaneIcon data={data} date={date} />
        <div className="mt-1 font-size-08">
          <p>{data.FLIGHT_NAME}</p>
          <p>{data.AIR_FREIGHT_NO}</p>
          <p className="font-weight-bold">
            {data.DEPARTURE_TIME} - {data.AIRRIVE_TIME}
          </p>
          <p className="font-weight-bold text-danger">
            {data.AIR_FREIGHT_MEMO ? "*" + data.AIR_FREIGHT_MEMO : " "}
          </p>
        </div>
      </>
    );
  };

  const dateFromString = new Date(sm_DEPARTURE_DATE);

  const yearFromString = dateFromString.getFullYear();
  const monthFromString = dateFromString.getMonth();

  for (let key in selectWeekDateList) {
    const currentDate = selectWeekDateList[key].realDate;
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    if (
      yearFromString === currentYear &&
      monthFromString === currentMonth &&
      item[`sm_INFO_${key}`]
    ) {
      selectWeekDateList[key].display = true;
    } else {
      selectWeekDateList[key].display = false;
    }
  }

  let isAllFalse = true;
  for (let key in selectWeekDateList) {
    if (selectWeekDateList[key].display) isAllFalse = false;
  }

  if (isAllFalse) return null;

  return (
    <div className="mb-2 bg-light rounded">
      <div className="row m-0 p-0">
        <div className="col-12 m-0 p-0">
          <div className="row h-100 m-0 p-0 text-center">
            <div
              className="col-auto flex-grow-1 m-0 p-2 d-flex flex-column justify-content-start align-items-center"
              style={{ width: 100 }}
            >
              <span className="mb-2 font-weight-bold text-danger">
                {t("commonDate.days.sun")}
                {selectWeekDateList.SUN.dateTxt}
              </span>
              {selectWeekDateList.SUN.display && item.sm_INFO_SUN && (
                <AirFreightItem
                  data={item.sm_INFO_SUN}
                  date={selectWeekDateList.SUN}
                />
              )}
            </div>
            <div
              className="col-auto flex-grow-1 m-0 p-2 d-flex flex-column justify-content-start align-items-center"
              style={{ width: 100 }}
            >
              <span className="mb-2 font-weight-bold">
                {t("commonDate.days.mon")}
                {selectWeekDateList.MON.dateTxt}
              </span>
              {selectWeekDateList.MON.display && item.sm_INFO_MON && (
                <AirFreightItem
                  data={item.sm_INFO_MON}
                  date={selectWeekDateList.MON}
                />
              )}
            </div>
            <div
              className="col-auto flex-grow-1 m-0 p-2 d-flex flex-column justify-content-start align-items-center"
              style={{ width: 100 }}
            >
              <span className="mb-2 font-weight-bold">
                {t("commonDate.days.tue")}
                {selectWeekDateList.TUE.dateTxt}
              </span>
              {selectWeekDateList.TUE.display && item.sm_INFO_TUE && (
                <AirFreightItem
                  data={item.sm_INFO_TUE}
                  date={selectWeekDateList.TUE}
                />
              )}
            </div>
            <div
              className="col-auto flex-grow-1 m-0 p-2 d-flex flex-column justify-content-start align-items-center"
              style={{ width: 100 }}
            >
              <span className="mb-2 font-weight-bold">
                {t("commonDate.days.wed")}
                {selectWeekDateList.WED.dateTxt}
              </span>
              {selectWeekDateList.WED.display && item.sm_INFO_WED && (
                <AirFreightItem
                  data={item.sm_INFO_WED}
                  date={selectWeekDateList.WED}
                />
              )}
            </div>
            <div
              className="col-auto flex-grow-1 m-0 p-2 d-flex flex-column justify-content-start align-items-center"
              style={{ width: 100 }}
            >
              <span className="mb-2 font-weight-bold">
                {t("commonDate.days.thu")}
                {selectWeekDateList.THU.dateTxt}
              </span>
              {selectWeekDateList.THU.display && item.sm_INFO_THU && (
                <AirFreightItem
                  data={item.sm_INFO_THU}
                  date={selectWeekDateList.THU}
                />
              )}
            </div>
            <div
              className="col-auto flex-grow-1 m-0 p-2 d-flex flex-column justify-content-start align-items-center"
              style={{ width: 100 }}
            >
              <span className="mb-2 font-weight-bold">
                {t("commonDate.days.fri")}
                {selectWeekDateList.FRI.dateTxt}
              </span>
              {selectWeekDateList.FRI.display && item.sm_INFO_FRI && (
                <AirFreightItem
                  data={item.sm_INFO_FRI}
                  date={selectWeekDateList.FRI}
                />
              )}
            </div>
            <div
              className="col-auto flex-grow-1 m-0 p-2 d-flex flex-column justify-content-start align-items-center"
              style={{ width: 100 }}
            >
              <span className="mb-2 font-weight-bold text-primary">
                {t("commonDate.days.sat")}
                {selectWeekDateList.SAT.dateTxt}
              </span>
              {selectWeekDateList.SAT.display && item.sm_INFO_SAT && (
                <AirFreightItem
                  data={item.sm_INFO_SAT}
                  date={selectWeekDateList.SAT}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
